module.exports = __webpack_public_path__ + "img/back-arrow-gray.ec434d94.svg";